export const ROLE_VALUE = {
  ADMIN: "ROLE_ADMIN",
  CLINIC: "ROLE_CLINIC",
};

export const ROLE = [
  { label: "ROLE_FACILITY", value: "ROLE_FACILITY" },
  { label: "ROLE_USER", value: "ROLE_USER" },
  { label: "ROLE_ADMIN", value: "ROLE_ADMIN" },
];
export const GENDER = [
  { label: "男", value: "MALE" },
  { label: "女", value: "FEMALE" },
];
export const PATIENT_RELATIONSHIP = [
  { label: "本人", value: 1 },
  { label: "父", value: 2 },
  { label: "義父", value: 3 },
  { label: "祖父", value: 4 },
  { label: "夫", value: 5 },
  { label: "兄", value: 6 },
  { label: "弟", value: 7 },
  { label: "息子", value: 8 },
  { label: "叔父", value: 9 },
  { label: "母", value: 10 },
  { label: "義母", value: 11 },
  { label: "祖母", value: 12 },
  { label: "妻", value: 13 },
  { label: "姉", value: 14 },
  { label: "妹", value: 15 },
  { label: "娘", value: 16 },
  { label: "叔母", value: 17 },
  { label: "いとこ", value: 18 },
  { label: "友人・知人", value: 19 },
  { label: "サービス利用者", value: 20 },
  { label: "その他", value: 21 },
];
export const LEVEL_CARE = [
  { label: "設定なし・不明", value: 0 },
  { label: "要支援１", value: 1 },
  { label: "要支援２", value: 2 },
  { label: "要介護１", value: 3 },
  { label: "要介護２", value: 4 },
  { label: "要介護３", value: 5 },
  { label: "要介護４", value: 6 },
  { label: "要介護５", value: 7 },
];
export const LIVING_SITUATION = [
  { label: "家族と同居", value: 1 },
  { label: "一人暮らし", value: 2 },
  { label: "施設での暮らし", value: 3 },
  { label: "それ以外", value: 98 },
];
export const DISEASE_CODE = [
  { label: "特に病気はなし", value: 0 },
  { label: "がん", value: 1 },
  { label: "高血圧", value: 2 },
  { label: "脂質異常症", value: 3 },
  { label: "糖尿病", value: 4 },
  { label: "心疾患", value: 5 },
  { label: "脳血管障害", value: 6 },
  { label: "精神神経疾患", value: 7 },
  { label: "認知症", value: 8 },
  { label: "その他", value: 98 },
];
export const SYMPTOM_CODE = [
  { label: "特に病気はなし", value: 0 },
  { label: "身体に不自由なところがある", value: 1 },
  { label: "物忘れがある", value: 2 },
  { label: "過去１年間に転んだことがある", value: 3 },
  { label: "徘徊する傾向がある", value: 4 },
  { label: "寝て過ごすことが多い", value: 5 },
  { label: "便秘になりやすい", value: 6 },
  { label: "１回の尿量が多く、漏れることがある", value: 7 },
  { label: "トイレに間に合わないことがある", value: 8 },
  { label: "知的発達に遅れがある", value: 9 },
  { label: "排泄物を自分で触ることがある", value: 10 },
  { label: "気持ちのコントロールが苦手である", value: 11 },
];
export const RECORD_TYPE = [
  { label: "体温", value: 0 },
  { label: "血圧", value: 1 },
  { label: "脈拍", value: 2 },
  { label: "血中酸素濃度", value: 3 },
  { label: "体重", value: 4 },
  { label: "食事量", value: 5 },
  { label: "水分量", value: 6 },
  { label: "服薬", value: 7 },
  { label: "排尿", value: 8 },
  { label: "排便", value: 9 },
  { label: "入浴", value: 10 },
  { label: "睡眠", value: 11 },
  { label: "メモ", value: 12 },
];
export const DEFECATION = [
  { label: "コロコロ", value: 1 },
  { label: "硬い", value: 2 },
  { label: "やや硬い", value: 3 },
  { label: "普通", value: 4 },
  { label: "柔らかい", value: 5 },
  { label: "どろ状", value: 6 },
  { label: "水っぽい", value: 7 },
];
export const TAKE_A_SHOWER = [
  { label: "入浴", value: 1 },
  { label: "シャワー浴", value: 2 },
  { label: "清拭", value: 3 },
];
export const POSITION_FOR_SLEEPING = [
  { label: "うつ伏せ", value: 0 },
  { label: "左向き", value: 3 },
  { label: "右向き", value: 1 },
  { label: "直立", value: 4 },
  { label: "左斜め", value: 9 },
  { label: "仰向け", value: 2 },
  { label: "右斜め", value: 8 },
  { label: "姿勢異常", value: 5 },
];
export const FOOD_INTAKE = [
  { label: "少ない", value: 1 },
  { label: "普通", value: 2 },
  { label: "多い", value: 3 },
];
export const WATER_INTAKE = [
  { label: "少ない", value: 1 },
  { label: "普通", value: 2 },
  { label: "多い", value: 3 },
];
export const pageOptions = [
  { label: 15, value: 15 },
  { label: 30, value: 30 },
  { label: 50, value: 50 },
  { label: 100, value: 100 },
];
export const DIAPER_STATUS = [
  { label: "R", value: "R" },
  { label: "O", value: "O" },
  { label: "Y", value: "Y" },
  { label: "YG", value: "YG" },
];
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const SECRET_IV_KEY = process.env.REACT_APP_SECRET_IV_KEY;
export const ERRORS_CODE = {
  ERROR_400: 400,
  ERROR_401: 401,
  ERROR_422: 422,
  ERROR_409: 409,
  ERROR_500: 500,
};
export const ERROR_MSG = {
  REQUIRE: "入力してください",
  MAC_INVALID: "有効的なMACアドレスを入力してください。",
  EMAIL_NOT_MATCH: "登録されたメールアドレスを一致しません。",
  EMAIL_INVALID:
    "メールアドレス形式を正しく入力しません。もう一度入力してください。",
  PHONE_INVALID: "携帯電話番号を半角数字で入力してください。",
  PASSWORD_NOT_MATCH: "パスワードは一致しません。",
  EMAIL_NOT_MATCH_WITH_CURRENT_USER:
    "メールアドレスは現在のアカウントと一致しません。もう一度入力してください。",
  PW_LOGIN_RULE: "パスワードを8～36半角英数字で入力してください。",
};
export const ERROR_MSG_REQUIRE = {
  LAST_NAME: "姓を入力してください",
  FIRST_NAME: "名を入力してください",
  GROUP: "グループを選択してください",
  GENDER: "性別を選択してください",
  BIRTHDAY: "生年月日を選択してください",
  AREA: "お住まいの地域を選択してください",
  LEVEL_CARE: "要介護度を選択してください",
  LIVING_SITUATION: "生活状況を選択してください",
  DIAPER_TYPE: "おむつ種類を選択してください",
  FACILITY_NAME: "施設名を入力してください",
  FACILITY_PHONE: "施設代表電話番号を入力してください",
  PARTNER: "提携先を入力してください",
  ZIP_CODE: "郵便番号を入力してください",
  FACILITY_EMAIL: "施設登録メールアドレスを入力してください",
  NUMBER_OF_LICENSES: "ライセンス数を入力してください",
  ADDRESS: "都道府県を入力してください",
  BUILDING_ADDRESS: "番地名、建物名を入力してください",
  PIC: "担当者名を入力してください",
  GROUP_NAME: "グループ名を入力してください",
};
export const ERROR_ID_LENGTH = () => {
  return `事業者IDを8桁の半角数字で入力してください。`;
};
export const ERROR_MAX_LENGTH = (num) => {
  return `${num}以下桁数を入力してください。`;
};
export const ERROR_MIN_LENGTH = (num) => {
  return `${num}以上桁数を入力してください`;
};

export const CONFIG_COOKIES = {
  path: "/",
  domain: "URINE",
};

export const IMAGE_TYPE_UPLOAD = ["image/png", "image/jpeg", "image/jpg"];
export const IMAGE_MAX_SIZE = 10485760; // 10MB

export const PROVINCES_MAPPING = {
  1: "北海道",
  2: "青森県",
  3: "岩手県",
  4: "宮城県",
  5: "秋田県",
  6: "山形県",
  7: "福島県",
  8: "茨城県",
  9: "栃木県",
  10: "群馬県",
  11: "埼玉県",
  12: "千葉県",
  13: "東京都",
  14: "神奈川県",
  15: "新潟県",
  16: "富山県",
  17: "石川県",
  18: "福井県",
  19: "山梨県",
  20: "長野県",
  21: "岐阜県",
  22: "静岡県",
  23: "愛知県",
  24: "三重県",
  25: "滋賀県",
  26: "京都府",
  27: "大阪府",
  28: "兵庫県",
  29: "奈良県",
  30: "和歌山県",
  31: "鳥取県",
  32: "島根県",
  33: "岡山県",
  34: "広島県",
  35: "山口県",
  36: "徳島県",
  37: "香川県",
  38: "愛媛県",
  39: "高知県",
  40: "福岡県",
  41: "佐賀県",
  42: "長崎県",
  43: "熊本県",
  44: "大分県",
  45: "宮崎県",
  46: "鹿児島県",
  47: "沖縄県",
};

export const PROVINCE_OPTIONS = Object.keys(PROVINCES_MAPPING).map((key) => ({
  value: key,
  label: PROVINCES_MAPPING[key],
}));

export const characters = [
  {
    "id": 1,
    "image": "assets/images/character1.png",
    "name": "ぐまんくん",
    "birthday": "2016年1月1日",
    "zodiac": "やぎ座",
    "personality": "がまん強い"
  },
  {
    "id": 2,
    "image": "assets/images/character2.png",
    "name": "ぱっぴーちゃん",
    "birthday": "2016年2月2日",
    "zodiac": "みずがの座",
    "personality": "マイペース"
  },
  {
    "id": 3,
    "image": "assets/images/character3.png",
    "name": "ぶぶちゃん",
    "birthday": "2016年3月3日",
    "zodiac": "うお座",
    "personality": "おとなしい"
  },
  {
    "id": 4,
    "image": "assets/images/character4.png",
    "name": "ねずみんくん",
    "birthday": "2016年4月4日",
    "zodiac": "おひつじ座",
    "personality": "こわいもの知らず"
  },
  {
    "id": 5,
    "image": "assets/images/character5.png",
    "name": "ぱおたくん",
    "birthday": "2016年5月5日",
    "zodiac": "おうし座",
    "personality": "じっくりコツコツ"
  },
  {
    "id": 6,
    "image": "assets/images/character6.png",
    "name": "きっきーちゃん",
    "birthday": "2016年6月6日",
    "zodiac": "ふたご座",
    "personality": "あかるい"
  },
  {
    "id": 7,
    "image": "assets/images/character7.png",
    "name": "めいちゃん",
    "birthday": "2016年7月7日",
    "zodiac": "かに座",
    "personality": "やさしい"
  },
  {
    "id": 8,
    "image": "assets/images/character8.png",
    "name": "とらじくん",
    "birthday": "2016年8月8日",
    "zodiac": "しし座",
    "personality": "ワイルド"
  },
  {
    "id": 9,
    "image": "assets/images/character9.png",
    "name": "くわちゃん",
    "birthday": "2016年9月9日",
    "zodiac": "おとめ座",
    "personality": "まじめ"
  },
  {
    "id": 10,
    "image": "assets/images/character10.png",
    "name": "ねっぴちゃん",
    "birthday": "2016年10月10日",
    "zodiac": "てんびん座",
    "personality": "アイドル"
  },
  {
    "id": 11,
    "image": "assets/images/character11.png",
    "name": "るーろくん",
    "birthday": "2016年11月11日",
    "zodiac": "さそり座",
    "personality": "ロマンティスト"
  },
  {
    "id": 12,
    "image": "assets/images/character12.png",
    "name": "りったんくん",
    "birthday": "2016年12月12日",
    "zodiac": "いて座",
    "personality": "ひらめき"
  }
];
